import { useRef, useEffect } from 'react';

export const useDebounceHandler = (delay: number = 1000, origin?: string) => {
  const isBlocked = useRef(false);

  useEffect(() => {
    if (origin) {
      isBlocked.current = false;
    }
  }, [origin]);

  function debounceAction<T extends (...args: Parameters<T>) => void>(cb: T) {
    return (...args: Parameters<T>) => {
      if (isBlocked.current) return;

      isBlocked.current = true;

      cb(...args);

      setTimeout(() => {
        isBlocked.current = false;
      }, delay);
    };
  }

  const debounceAsync = <T extends (...args: Parameters<T>) => Promise<void>>(cb: T) => {
    return async (...args: Parameters<T>) => {
      if (isBlocked.current) return;

      isBlocked.current = true;

      await cb(...args);

      setTimeout(() => {
        isBlocked.current = false;
      }, delay);
    };
  };

  return {
    debounceAction,
    debounceAsync,
  };
};
